import React, { Component } from "react"
import { connect } from "react-redux"
import { requestResource } from "home/api_request"
import { SaebStudentPerformanceTablePresentation } from "home/components/saeb_proficiency_analysis"
import { hasFiltersApplied } from "home/components/filters/filter_helper"

const RESOURCE = "saeb_proficiency_analysis/student_performance"

class SaebStudentPerformanceTableContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tableData: {
        data: null,
        columns: null
      }
    }
  }

  componentDidMount () {
    this.updateData()
  }

  componentDidUpdate (prevProps) {
    if (JSON.stringify(prevProps.filters) != JSON.stringify(this.props.filters)) {
      this.updateData()
    }
  }

  updateData () {
    const { filters } = this.props

    requestResource(RESOURCE, filters, response => this.setChartConfigFromResponse(response))
  }

  setChartConfigFromResponse (response) {
    this.setState({
      tableData: response.data
    })
  }

  render () {
    if (this.state.tableData.data == null) {
      return <div>Aguardando Dados</div>
    } else {
      return (
        <SaebStudentPerformanceTablePresentation
          tableData={this.state.tableData}
          resource={RESOURCE}
          hasFilters={hasFiltersApplied(this.props.filters)}
        />
      )
    }
  }
}

const mapStateToProps = state => {
  return {
    filters: {
      userId: state.filters.userId,
      schoolYear: state.filters.schoolYear,
      schoolClass: state.filters.schoolClass,
      schoolId: state.filters.schoolId,
      "saebAnalysis/studentPerformance/examId": state.filters["saebAnalysis/studentPerformance/examId"]
    }
  }
}

export default connect(mapStateToProps)(SaebStudentPerformanceTableContainer)
